export default function (Vue) {
  let authenticatedUser = {}

  Vue.auth = {

    setToken (token, expiration) {
      Vue.ls.set('tokenPortal', token)
      Vue.ls.set('expiration', expiration)
    },

    getToken () {
      var expiration = Vue.ls.get('expiration')
      var token = Vue.ls.get('tokenPortal')

      if (!token || !expiration) {
        return null
      }

      if (Date.now() / 1000 > parseInt(expiration)) {
        this.destroyToken()
        return null
      } else {
        return token
      }
    },

    destroyToken () {
      Vue.ls.remove('tokenPortal')
      Vue.ls.remove('expiration')
    },

    authenticated () {
      if (this.getToken()) {
        return true
      } else { return false }
    },

    setAuthenticatedUser (data) {
      authenticatedUser = data
    },

    getAuthenticatedUser () {
      return authenticatedUser
    }

  }

  Object.defineProperties(Vue.prototype, {

    $auth: {
      get () {
        return Vue.auth
      }
    }

  })
}
